import './App.css';
import './index.css';
import React from 'react'
import Login from './components/Login/Login.js'
import GameSelector from './components/Selectors/GameSelector/GameSelector.js'
import Header from "./components/Header";
import Popup from "./components/Popup";
import agent from "./agent";
import {MODER_ROLE_KEY, USER_ROLE_KEY} from "./constants/Constants";
import ModeratorPanel from "./components/Moderator/ModeratorPanel";
import background from './images/background.svg'
import UserPanel from "./components/User/UserPanel";
import DictionaryWindow from "./components/InGameUI/Windows/DictionaryWindow";

class App extends React.Component {
    constructor() {
        super();
        this.state = {
            auth: {
                token: agent.user.getToken()
            },
            user: {
                role: null,
                fullName: ""
            },
            popup: {
                message: "test",
                isShow: false,
                isButtonInactive: false
            },
            game: {
                id: null,
                status: 0
            },
            showDictionary: false,
            currentDictionaryPage: "",
            showAlert: false,
            currentGames: [],
        }

        this.checkGameListTimeout = null;
        this.alertMessage = null;

        window.agent = agent;

        window.alert = this.showPopup.bind(this);
    }

    checkGameList() {
        if (agent.user.getToken()) {
            if (this.checkGameListTimeout) {
                clearTimeout(this.checkGameListTimeout);
            }
            agent.Game.getGameList((gameList) => {
                console.log(gameList)
                if (gameList.data.length > 0) {
                    if (gameList.data.length > 1) {
                        this.setState({
                            currentGames: gameList.data
                        })
                        if (localStorage.getItem("selectedGame")) {
                            let selectedGame = JSON.parse(localStorage.getItem("selectedGame"));
                            let threeDays = 1000 * 3600 * 24 * 3; // сек * минуты * часы * дни

                            if (Date.now() - selectedGame.date <= threeDays && gameList.data.filter(el => el.uuid === selectedGame.id).length)
                                this.setState({
                                    game: {
                                        id: selectedGame.id
                                    }
                                })
                            else
                                localStorage.removeItem("selectedGame");
                        }
                    } else {
                        this.setState({
                            game: {
                                id: gameList.data[0].uuid
                            }
                        });
                    }
                } else {
                    this.checkGameListTimeout = setTimeout(() => {
                        this.checkGameList()
                    }, 5000)
                }
            });

            this.getGamePlayers();
        }
    }

    getGamePlayers() {
        if (!this.state.game.id) {
            setTimeout(() => {this.getGamePlayers()}, 500);
        } else {
            if (MODER_ROLE_KEY === this.state.user.role) {
                agent.Game.getPlayers(this.state.game.id, (response) => {
                    agent.user.availablePlayers = response.users;
                });
            }
        }
    }

    InitPage() {
        this.setState({
            auth: {
                token: agent.user.getToken()
            },
            user: {
                role: null,
                fullName: ""
            },
            popup: {
                message: "test",
                isShow: false
            },
            game: {
                id: null,
                game_info: null
            },
            showDictionary: false,
            currentDictionaryPage: ""
        })

        if (agent.user.hasToken()) {
            this.checkNeedsTokenRefresh();

            this.checkGameList();
            agent.UserAPI.getProfile((profile) => {
                console.log(profile)
                let state = this.state;
                state.user = {
                    role: profile.role,
                    fullName: `${profile.firstname} ${profile.lastname}`
                };
                agent.user.role = profile.role;
                this.setState(state)
            })
        }
    }

    checkNeedsTokenRefresh() {
        let timeNow = Date.now();
        let twentyThree = 1000 * 3600 * 23; // 23 часа * 3600 сек в час * 1000 мс

        if (timeNow - (+agent.user.getLastLogin()) > twentyThree) {
            agent.Auth.refresh(this.state.auth.token);

            this.setState({
                auth: {
                    token: agent.user.getToken()
                }
            })

            console.log("token refreshed!")
        }
    }

    componentDidMount() {
        this.InitPage();
        agent.onStartLoad = () => {
            this.setState({
                isLoading: true
            });
        }
        agent.onEndLoad = () => {
            this.setState({
                isLoading: false
            });
        }
    }

    componentWillUnmount() {
      clearTimeout(this.checkGameListTimeout);
    }

  showPopup(message, buttonsInactive = false, html = false) {
        if (this.state.popup.isShow) {
            setTimeout(() => {this.showPopup(message, buttonsInactive, html);}, 5000);
            return;
        }

        this.setState({
            popup: {
                isShow: true,
                message: message,
                isButtonInactive: buttonsInactive,
                html: html
            }
        });
    }

    handlePopupMessages(message) {
        this.showPopup(message)
    }

    handleClosePopup() {
        this.setState({
            popup: {
                isShow: false,
                message: ""
            }
        });
    }

    handleChangeLoginState() {
        if (this.state.currentGames.length > 1) {
            this.setState({
                game: {
                    id: null
                },
                currentGames: []
            });
            localStorage.removeItem("selectedGame");

            console.log("back")
        } else {
            this.setState({
                auth: {
                    token: agent.user.getToken()
                }
            });
        }

        this.InitPage();
    }

    showWaitGameDialog() {
        this.setState({
            popup: {
                isShow: true,
                isButtonInactive: true,
                message: 'Дождитесь, пока ваша игра начнётся'
            }
        });
    }

    toggleDictionary() {
        this.setState({
            showDictionary: !this.state.showDictionary
        })
    }

    openDictionaryAtPage(page) {
        this.setState({
            showDictionary: true,
            currentDictionaryPage: page
        })
    }

    selectSingleGame(uuid) {
        this.setState({
            game: {
                id: uuid
            }
        })

        localStorage.setItem("selectedGame", JSON.stringify({id: uuid, date: Date.now()}))

        this.getGamePlayers();
    }

    render() {
        let header = "";
        let panel = "";
        let login = "";

        let manyGames = this.state.currentGames.length > 1; // несколько игр
        let gameIsOn = !!this.state.game.id; // сейчас выбрана игра

        if (this.state.auth.token) {
            header = <Header role={this.state.user.role}
                             gameId={this.state.game.id}
                             fullName={this.state.user.fullName}
                             canLogout={!(manyGames && gameIsOn)}
                             onLogout={this.handleChangeLoginState.bind(this)}
                             onToggleDictionary={this.toggleDictionary.bind(this)}/>

            if (this.state.currentGames.length && !this.state.game.id) {
                panel = <GameSelector games={this.state.currentGames} onSelect={this.selectSingleGame.bind(this)}/>
            } else {
                if (this.state.user.role && this.state.game.id != null) {
                    switch (this.state.user.role) {
                        case USER_ROLE_KEY:
                            panel = <UserPanel gameId={this.state.game.id}
                                               onError={this.handlePopupMessages.bind(this)}
                                               showWaitGameDialog={this.showWaitGameDialog.bind(this)}
                                               openDictionaryAt={this.openDictionaryAtPage.bind(this)}/>

                            break;
                        case MODER_ROLE_KEY:
                            panel =
                                <ModeratorPanel gameId={this.state.game.id}
                                                onError={this.handlePopupMessages.bind(this)}
                                                openDictionaryAt={this.openDictionaryAtPage.bind(this)}/>
                            break;
                        default:
                            break;
                    }
                }
            }
        } else {
            login =
                <Login onSubmit={this.handleChangeLoginState.bind(this)} onError={this.handlePopupMessages.bind(this)}/>
        }
        let popup = this.state.popup.isShow ? <Popup html={this.state.popup.html}
                                                     onClose={this.handleClosePopup.bind(this)}
                                                     isButtonInactive={this.state.popup.isButtonInactive}>
                {this.state.popup.message}
            </Popup>
            : "";

        let dictionary = this.state.showDictionary && <DictionaryWindow currentPage={this.state.currentDictionaryPage}
                                                                        onToggle={this.toggleDictionary.bind(this)}/>;
        return <div className="App" style={{backgroundImage: `url(${background})`}}>
            {header}
            {panel}
            {dictionary}
            {login}
            {popup}

        </div>
    }
}

export default App;
